//  ViewIndividualTest.js
//
//  Updated 2/8.
//
//  Abstract: View individual tests.
//  TODO Image gallery
//  Modal gallery

//  React
import React, { useState } from 'react';
import axios from 'axios';

//  Material-ui components
import { makeStyles, CssBaseline, Container, Drawer, List, Grid, ListItem, ListItemIcon, ListItemText} from '@material-ui/core';

//	Sidebar width
const drawerWidth = 240;

//  CSS styles
const useStyles = makeStyles((theme) => ({
    root: {
    },
}));

export default function ViewIndividualTest(props) {

    //  CSS classes
    const classes = useStyles();

    //  TODO data
    const patientId = "P1234567";
    const testId = "T1234567";
    const plannedTestStartDate = "12/02/2021";
    const actualTestStartDate = "12/03/2021";
    const patchIdsArray = "[1, 4, 6, 11]";
    const currentDayOfTest = "3/5";
    const numberOfDay1Captures = "1";
    const numberOfDay3Captures = "21";
    const numberOfDay5Captures = "3";

    function ListItemLink(props) {
        return <ListItem button component="a" {...props} />;
    }

    //  Component rendering
    return (
        <>
            <Container>
                <CssBaseline />
                <div className={classes}>
                    <Grid container direction="row">
                        <Grid item>
                            <List component="nav2" aria-label="secondary mailbox folders">
                                <ListItemLink href="#simple-list">
                                    <ListItemText primary="Test Information" />
                                </ListItemLink>
                                <ListItemLink href="#simple-list">
                                    <ListItemText primary="Day 1 Captures" />
                                </ListItemLink>
                                <ListItemLink href="#simple-list">
                                    <ListItemText primary="Day 3 Captures" />
                                </ListItemLink>
                                <ListItemLink href="#simple-list">
                                    <ListItemText primary="Day 5 Captures" />
                                </ListItemLink>
                            </List>
                        </Grid>


                        <Grid item>
                            <List component="nav" aria-label="secondary mailbox folders">
                                <ListItem >
                                    <ListItemText primary={`Patient ID ${patientId}`} />
                                </ListItem>
                                <ListItem >
                                    <ListItemText primary={`Test ID: ${testId}`} />
                                </ListItem>
                                <ListItem >
                                    <ListItemText primary={`Planned Test Start Date: ${plannedTestStartDate}`} />
                                </ListItem>
                                <ListItem >
                                    <ListItemText primary={`Actual Test Start Date: ${actualTestStartDate}`} />
                                </ListItem>
                                <ListItem >
                                    <ListItemText primary={`Patch ID Array: ${patchIdsArray}`} />
                                </ListItem>
                                <ListItem >
                                    <ListItemText primary={`Current Day of Test: ${currentDayOfTest}`} />
                                </ListItem>
                                <ListItem >
                                    <ListItemText primary={`Number of Day 1 Photos Taken: ${numberOfDay1Captures}`} />
                                </ListItem>
                                <ListItem >
                                    <ListItemText primary={` Number of Day 3 Photos Taken: ${numberOfDay3Captures}`} />
                                </ListItem>
                                <ListItem >
                                    <ListItemText primary={`Number of Day 5 Photos Taken: ${numberOfDay5Captures}`} />
                                </ListItem>
                            </List>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </>
    );
}



// import React from 'react';
// import PropTypes from 'prop-types';
// import { makeStyles } from '@material-ui/core/styles';
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';
// import Typography from '@material-ui/core/Typography';
// import Box from '@material-ui/core/Box';

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`vertical-tabpanel-${index}`}
//       aria-labelledby={`vertical-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box p={3}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.any.isRequired,
//   value: PropTypes.any.isRequired,
// };

// function a11yProps(index) {
//   return {
//     id: `vertical-tab-${index}`,
//     'aria-controls': `vertical-tabpanel-${index}`,
//   };
// }

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//     display: 'flex',
//     height: 224,
//   },
//   tabs: {
//     borderRight: `1px solid ${theme.palette.divider}`,
//   },
// }));

// export default function VerticalTabs() {
//   const classes = useStyles();
//   const [value, setValue] = React.useState(0);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   return (
//     <div className={classes.root}>
//       <Tabs
//         orientation="vertical"
//         variant="scrollable"
//         value={value}
//         onChange={handleChange}
//         aria-label="Vertical tabs example"
//         className={classes.tabs}
//       >
//         <Tab label="Item One" {...a11yProps(0)} />
//         <Tab label="Item Two" {...a11yProps(1)} />
//         <Tab label="Item Three" {...a11yProps(2)} />
//         <Tab label="Item Four" {...a11yProps(3)} />
//         <Tab label="Item Five" {...a11yProps(4)} />
//         <Tab label="Item Six" {...a11yProps(5)} />
//         <Tab label="Item Seven" {...a11yProps(6)} />
//       </Tabs>
//       <TabPanel value={value} index={0}>
//         Item One
//       </TabPanel>
//       <TabPanel value={value} index={1}>
//         Item Two
//       </TabPanel>
//       <TabPanel value={value} index={2}>
//         Item Three
//       </TabPanel>
//       <TabPanel value={value} index={3}>
//         Item Four
//       </TabPanel>
//       <TabPanel value={value} index={4}>
//         Item Five
//       </TabPanel>
//       <TabPanel value={value} index={5}>
//         Item Six
//       </TabPanel>
//       <TabPanel value={value} index={6}>
//         Item Seven
//       </TabPanel>
//     </div>
//   );
// }



// import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// // import Divider from '@material-ui/core/Divider';
// // import InboxIcon from '@material-ui/icons/Inbox';
// // import DraftsIcon from '@material-ui/icons/Drafts';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: '100%',
//     maxWidth: 360,
//     backgroundColor: theme.palette.background.paper,
//   },
// }));

// function ListItemLink(props) {
//   return <ListItem button component="a" {...props} />;
// }

// export default function SimpleList() {
//     const classes = useStyles();

//     return (
//         <div className={classes.root}>

//         </div>
//     );
// }

// // import React from 'react';
// // import { makeStyles } from '@material-ui/core/styles';
// // import Modal from '@material-ui/core/Modal';

// // function rand() {
// //   return Math.round(Math.random() * 20) - 10;
// // }

// // function getModalStyle() {
// //   const top = 50 + rand();
// //   const left = 50 + rand();

// //   return {
// //     top: `${top}%`,
// //     left: `${left}%`,
// //     transform: `translate(-${top}%, -${left}%)`,
// //   };
// // }

// // const useStyles = makeStyles((theme) => ({
// //   paper: {
// //     position: 'absolute',
// //     width: 400,
// //     backgroundColor: theme.palette.background.paper,
// //     border: '2px solid #000',
// //     boxShadow: theme.shadows[5],
// //     padding: theme.spacing(2, 4, 3),
// //   },
// // }));

// // export default function SimpleModal() {
// //   const classes = useStyles();
// //   // getModalStyle is not a pure function, we roll the style only on the first render
// //   const [modalStyle] = React.useState(getModalStyle);
// //   const [open, setOpen] = React.useState(false);

// //   const handleOpen = () => {
// //     setOpen(true);
// //   };

// //   const handleClose = () => {
// //     setOpen(false);
// //   };

//   const body = (
//     <div style={modalStyle} className={classes.paper}>
//       <h2 id="simple-modal-title">Text in a modal</h2>
//       <p id="simple-modal-description">
//         Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
//       </p>
//       <SimpleModal />
//     </div>
//   );

//   return (
//     <div>
//       <button type="button" onClick={handleOpen}>
//         Open Modal
//       </button>
//       <Modal
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="simple-modal-title"
//         aria-describedby="simple-modal-description"
//       >
//         {body}
//       </Modal>
//     </div>
//   );
// }
